import { FC } from "react";

type FlowStatusBarProps = {
  states: { id: string; name: string; count: number; disabled?: boolean }[];
  steps: { id: string; name: string; count: number }[];
  selectedState: string;
  selectedStep: string;
  onClick: (stateId: string, stepId?: string) => void;
};
export const FlowStatusBar: FC<FlowStatusBarProps> = (props) => {
  return (
    <div className="flex gap-4">
      <div className="flex flex-1 flex-col gap-4">
        {props.states.map((state) => (
          <FlowStepButton key={state.id} title={state.name} count={state.count} selected={props.selectedState === state.id} disabled={state.disabled || state.count === 0} size={"large"} onClick={() => props.onClick(state.id)} />
        ))}
      </div>
      <div className="flex flex-1 flex-col gap-4">
        {props.steps.map((step) => {
          return (
            <FlowStepButton
              key={step.id}
              title={step.name}
              count={step.count}
              selected={props.selectedStep === step.id}
              disabled={step.count === 0}
              onClick={() => props.onClick(props.selectedState, step.id)}
            />
          );
        })}
      </div>
    </div>
  );
};

type FlowStepButtonProps = { title: string; count?: number; selected: boolean; disabled?: boolean; size?: "large"; onClick: () => void };
const FlowStepButton: FC<FlowStepButtonProps> = (props) => {
  return (
    <button
      className={`flex w-full justify-between px-6 py-3 rounded-full border-2 ${props.disabled ? "text-gray-600 border-gray-600" : ""} ${props.size === "large" ? "text-md" : "text-xs"} ${props.selected ? "bg-gray-400" : ""}`}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <span>{props.title.toUpperCase()}</span> <span>{props.count}</span>
    </button>
  );
};
